import { useSubscription } from '@apollo/client';
import { gql } from 'graphql-tag';

export const RESUME_PARSING_PROCESSING_SUBSCRIPTION = gql`
  subscription ResumeParsingProcessingCompleted($userUri: String!) {
    resumeParsingProcessingCompleted(userUri: $userUri) {
      id
      userSlug
    }
  }
`;

const useResumeParsingProcessingSubscription = ({
  userUri,
  skipSubscription
}) => {
  const { data: { resumeParsingProcessingCompleted } = {} } = useSubscription(
    RESUME_PARSING_PROCESSING_SUBSCRIPTION,
    {
      variables: { userUri },
      skip: skipSubscription
    }
  );

  return resumeParsingProcessingCompleted || { id: null, userSlug: null };
};

export default useResumeParsingProcessingSubscription;
